import React, { useEffect, useRef, useState } from 'react';
import { DatePicker, Select, Table, Statistic, Tag } from 'antd';
import moment from 'moment';
import CurrencyIcon from '../../Common/CurrencyIcon';
import { useGlobalState } from '../../../store/state';
import { BsFilter } from 'react-icons/bs';
import { AiOutlineDownload } from 'react-icons/ai';
import { dateRangeSeperator } from '../../../utils';
import { ViewTransactions } from '../../../apis/Influencer/Wallet/ViewTransactions';
import './TranscationHistoryComponent.styles.scss';

const { RangePicker } = DatePicker;
const { Option } = Select;
const TranscationHistoryComponent = () => {
  const rangeRef = useRef();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [txnState, setTxnState] = useState({
    range: [moment().subtract(180, 'days'), moment()],
    filter: 'all',
    pager: {
      page: 1,
    },
    data: [],
  });

  // @note: common function for get transcatioins
  const getTransactionDetails = (dateRange, filter, page) =>{
    const _splitDates = dateRangeSeperator(dateRange);
    const _data = {
      filter: filter,
      page: page,
      ..._splitDates,
    };

    // @note: get transcations
    ViewTransactions(user.accessToken, _data).then(({ response, status }) =>{
      const _newTable = [];
      if (status === 200) {
        console.log('result', response);
        response.transactions.map(({ _id, transaction_notes, amount, transactionType, currency_type }) =>{
          const _v = {
            key: _id,
            desc: transaction_notes,
            currency: currency_type,
            status: transactionType,
            date: 'N/A',
            // date: `${moment().subtract((Math.random() * 20 ),'days').format('MMM Do YYYY')}`,
            amount: amount,
          };
          _newTable.push(_v);
        });
        setTxnState({
          ...txnState,
          filter: filter,
          pager: {
            hasNextPage: response.hasNextPage,
            hasPrevPage: response.hasPrevPage,
            page: response.page,
            nextPage: response.nextPage,
            prevPage: response.prevPage,
            totalPages: response.totalPages,
            limit: response.limit,
            transactionsCount: response.transactionsCount,
          },
          data: _newTable,
        });
      }
    });
  };

  useEffect(()=>{
    const { range, filter, pager: { page } } = txnState;
    getTransactionDetails(range, filter, page);
  }, []);


  // @note: table columns setup
  const columns = [
    {
      title: 'Description',
      dataIndex: 'desc',
    },
    {
      title: 'Date & time',
      dataIndex: 'date',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (_v) =>{
        switch (_v) {
        case 'debit':
          return <Tag color="red">{_v}</Tag>;
        case 'credited':
          return <Tag color="green">{_v}</Tag>;
        case 'withdraw':
          return <Tag color="green">{_v}</Tag>;
        default:
          return <Tag color="gold">{_v}</Tag>;
        }
      },
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      sorter: {
        compare: (a, b) => a.amount - b.amount,
        multiple: 2,
      },
      render: (_v) =>{
        return (
          <div className="text-left">
            <span className="d-inline-block"
              style={{ verticalAlign: '1px' }}>
              {CurrencyIcon()}&nbsp;
            </span>
            <Statistic className="custom_number_format"
              value={_v}
              precision={2}/>
          </div>
        );
      },
    },
    {
      title: 'Action',
      key: 'download',
      fixed: 'right',
      width: 150,
      render: (v) => <a href="#"
        target="_blank"
        className="common_button py-2 outlined small"
        title="Download Invoice"><AiOutlineDownload/> Invoice</a>,
    },
  ];

  // @note: page changing if more than
  const changePage = (page) =>{
    const { range, filter } = txnState;
    getTransactionDetails(range, filter, page);
  };

  // @note: change on payment mode
  const changeTypeFilter = (filter) =>{
    const { range } = txnState;
    setTxnState({
      ...txnState,
      filter: filter,
    });
    getTransactionDetails(range, filter, 1);
  };

  // @note: filter Date wise
  const dateFilter = (range) =>{
    const { filter } = txnState;
    setTxnState({
      ...txnState,
      range: range,
    });
    getTransactionDetails(range, filter, 1);
  };

  // @note: diable future dates in date filter
  const disableFutureDates = (current) =>{
    return current && current > moment().endOf('day');
  };
  return (
    <div className="common_card p-3 txn_history h-100">
      <div className="row">
        <div className="col-md-5">
          <span className="txn_history--title">Transaction History</span>
          <span className="pl-lg-3 mtt-2 mt-lg-0">
            <Select defaultValue={txnState.filter}
              className="d-inline-block common_select"
              style={{ minWidth: 130 }}
              onChange={changeTypeFilter}>
              <Option value="all">All</Option>
              <Option value="debit">Debited</Option>
              <Option value="credit">Credited</Option>
              <Option value="withdraw">Withdraw</Option>
            </Select>
          </span>
        </div>
        <div className="col-md-7 text-right">
          <span ><BsFilter size={24}/></span>
          <span className="pl-3">
            <RangePicker
              className="common_input"
              ref={rangeRef}
              style={{ maxWidth: 300 }}
              format={`MMM Do, YYYY`}
              disabledDate={disableFutureDates}
              defaultValue={txnState.range}
              onChange={dateFilter}
              ranges={{
                'Today': [moment(), moment()],
                'This Month': [moment().startOf('month'), moment()],
                'This Week': [moment().startOf('week'), moment()],
                'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                'Last 6 months': [moment().subtract(180, 'days'), moment()],
              }}
            />
          </span>
        </div>
        <div className="col-md-12 mt-4">
          <Table

            columns={columns}
            dataSource={txnState.data || []}
            pagination={{
              current: txnState.pager.page,
              total: txnState.pager.transactionsCount,
              onChange: (v) => changePage(v),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TranscationHistoryComponent;
